"use client";

import { NotificationBar } from "@litonarefin/components/NotificationBar";
import { isEmpty } from "lodash";
import { usePathname } from "next/navigation";
import {
  dateStringToMilliseconds,
  getNotificationData,
} from "@litonarefin/shared/notification/utils";

const Notification = ({ notifications }) => {
  const pathName = usePathname();

  const solidPathName = pathName.substring(1, pathName.length).split("/")?.[0];

  const { notification } = getNotificationData(notifications, solidPathName);

  return !isEmpty(notification) &&
    dateStringToMilliseconds(notification?.notification_end_time) > new Date().getTime() ? (
    <NotificationBar notification={notification} />
  ) : null;
};

export default Notification;
